// State hashing — the mechanism that proves determinism.
//
// Two runs of the same seed + the same input log must produce byte-identical state. The
// determinism test asserts on this hash, and phase-4 server-side replay verification compares the
// client's claimed final hash against its own.
//
// Hashing the raw IEEE-754 bits (not a rounded decimal) is deliberate: rounding would mask exactly
// the small divergences — a stray Math.sin, a variable dt — that this is here to catch.

const SCRATCH = new ArrayBuffer(8)
const F64 = new Float64Array(SCRATCH)
const U32 = new Uint32Array(SCRATCH)

/** Incremental FNV-1a (32-bit). */
export class StateHasher {
  private h = 0x811c9dc5

  mixU32(v: number): this {
    let h = this.h
    h ^= v & 0xff
    h = Math.imul(h, 0x01000193)
    h ^= (v >>> 8) & 0xff
    h = Math.imul(h, 0x01000193)
    h ^= (v >>> 16) & 0xff
    h = Math.imul(h, 0x01000193)
    h ^= (v >>> 24) & 0xff
    h = Math.imul(h, 0x01000193)
    this.h = h >>> 0
    return this
  }

  /** Mix a double by its exact bit pattern. NaN/-0 are intentionally distinguishable. */
  mixF64(v: number): this {
    F64[0] = v
    return this.mixU32(U32[0]).mixU32(U32[1])
  }

  digest(): number {
    return this.h >>> 0
  }

  hex(): string {
    return this.h.toString(16).padStart(8, '0')
  }
}
